export function isPaidQuizLocked(quiz = {}) {
  const freePaid = String(quiz.freePaid ?? quiz.free_paid ?? (quiz.plan === 'Free' ? 'F' : quiz.plan === 'Paid' ? 'P' : '')).trim().toUpperCase();
  return freePaid === 'P' && Number(quiz.paymentStatus ?? quiz.payment_status ?? 0) !== 1;
}

export function buildQuizPurchaseState(quiz = {}, context = {}) {
  return {
    stateId: Number(context.selectedState?.state_id || context.state_id || quiz.statesId || quiz.states_id || 0),
    quizId: Number(quiz.quizId || quiz.quiz_id || quiz.id || 0),
    seriesId: Number(context.selectedSeries?.series_id || context.selectedSeries?.id || context.series_id || quiz.seriesId || 0),
  };
}
